<template>
    <div v-if="quiz" class="ch-container">
        <vx-card class="mb-base" :title="quiz.title"
                 :subtitle="answers.length === 0 ? `لم تقم بإجابة أي سؤال في هذا الإختبار` : `لقد اكملت الاختبار عند (${completedAt})`"
                 subtitleColor="dark">
          <div slot="actions">
            <div v-if="quiz.is_confirmed" class="px-4 py-2 rounded-full bg-primary text-white">
              <span class="font-bold">{{totalMark}}  / </span>
              <span class="text-xl">{{quizMark}}</span>
            </div>
          </div>
          <quiz-question-item v-for="(question, index) in quiz.questions" :key="question.id" class="mb-4"
                              :question="question" :number="index" :viewMark="!!quiz.is_confirmed"
                              :answer="answers.find(answer => answer.question_id === question.id) || {mark: 0}"/>
        </vx-card>
    </div>
</template>

<script>
    import quizzesAPI from '@/api/quizzesAPI'
    import QuizQuestionItem from '@/views/course/quizzes/QuizQuestionItem'
    import seedRandom from 'seedrandom'

    export default {
        name: 'QuizResult',
        components: { QuizQuestionItem },
        data () {
            return {
                quiz: null,
                answers: []
            }
        },
        computed: {
            completedAt(){
                const at = new Date(Math.max.apply(null, this.answers.map(function(answer) {
                    return new Date(answer.updated_at)
                })))
                return this.$options.filters.date(at) + ' ' + this.$options.filters.time(at)
            },
            quizMark() {
                return this.answers.reduce((total, answer) => total + answer.mark ,0)
            },
            totalMark() {
                return this.quiz.questions.reduce((total, question) => total + question.mark ,0)
            },
        },
        beforeRouteEnter(to,from,next){
            quizzesAPI.setCourseId(to.params.course_id)
            quizzesAPI.getById(to.params.quiz_id).then(({data}) => {
                next(vm => {
                    vm.quiz = data.quiz
                    vm.answers = data.quiz_answers
                    if(vm.quiz.randomize_questions){
                        const random = seedRandom(vm.quiz.id * vm.user.id)
                        vm.quiz.questions.sort(() => random() - 0.5)
                    }
                })
            })
        }
    }
</script>
